import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// COMPONENTES
import { MyAccountComponent } from './my-account/my-account.component';
import { MyAccountIdentidadComponent } from './my-account-identidad/my-account-identidad.component';
import { MyAccountPasswordComponent } from './my-account-password/my-account-password.component';
import { MyAccountObraSocialComponent } from './my-account-obra-social/my-account-obra-social.component';
import { MyAccountEmailComponent } from './my-account-email/my-account-email.component';
import { MyAccountObraSocialListComponent } from './my-account-obra-social/my-account-obra-social-list/my-account-obra-social-list.component';
import { MyAccountIdentidadComercioComponent } from './my-account-identidad-comercio/my-account-identidad-comercio.component';
import { MyAccountIdentidadPrestadorComponent } from './my-account-identidad-prestador/my-account-identidad-prestador.component';
import { MyAccountUbicacionComponent } from './my-account-ubicacion/my-account-ubicacion.component';
import { MyAccountUbicacionesComponent } from './my-account-ubicaciones/my-account-ubicaciones.component';
import { MyAccountHorariosComponent } from './my-account-horarios/my-account-horarios.component';
import { MyAccountServiciosComponent } from './my-account-servicios/my-account-servicios.component';
import { MyAccountServicioComponent } from './my-account-servicio/my-account-servicio.component';
import { MyAccountProductoComponent } from './my-account-producto/my-account-producto.component';
import { MyAccountProductosComponent } from './my-account-productos/my-account-productos.component';
import { MyAccountMercadopagoComponent } from './my-account-mercadopago/my-account-mercadopago.component';
import { SeleccionUbicacionDefaultComponent } from './seleccion-ubicacion-default/seleccion-ubicacion-default.component';
import { SolicitudEspecialidadPrestacionComponent } from './solicitud-especialidad-prestacion/solicitud-especialidad-prestacion.component';
import { NgxMaskDirective } from 'ngx-mask';

@NgModule({
  declarations: [
    MyAccountComponent,
    MyAccountIdentidadComponent,
    MyAccountPasswordComponent,
    MyAccountObraSocialComponent,
    MyAccountEmailComponent,
    MyAccountObraSocialListComponent,
    MyAccountIdentidadComercioComponent,
    MyAccountIdentidadPrestadorComponent,
    MyAccountUbicacionComponent,
    MyAccountUbicacionesComponent,
    MyAccountHorariosComponent,
    MyAccountServiciosComponent,
    MyAccountServicioComponent,
    MyAccountProductoComponent,
    MyAccountProductosComponent,
    MyAccountMercadopagoComponent,
    SeleccionUbicacionDefaultComponent,
    SolicitudEspecialidadPrestacionComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    FormsModule,
    NgxMaskDirective
  ]
})
export class MyAccountModule { }
